<div class="container">
  <div *ngFor="let l of locks" class="lock-item">
    <lockvue-lock-info-short [value]="l"></lockvue-lock-info-short>
  </div>
</div>
